import   React               ,
       { useEffect           ,
         useState            }  from "react";



import   styles                 from './UserList.module.scss';

import   Tabs2                  from '../../widget/navigation/Tabs2';



import { User   }  from '../../../dataTypes/userManagment/types';

import { getUserById    }  from '../../../backendServices/userManagment/api';


import { ReplayStats         }  from '../customerFrontEventManagment/ReplayStats';
import { LiveStats           }  from '../customerFrontEventManagment/LiveStats';
import { PaymentList         }  from '../paymentManagment/PaymentList';
import { UserSheet           }  from './UserSheet';
import { UserLogin           }  from './UserLogin';

export interface UserInformations2Props {
  userId: number;
}

export const UserInformations2 = ({ userId }: UserInformations2Props) => {

  const [ user            , setUser            ] = useState <User|null> (null)
  const [  , setShowWaitingIcon ] = useState (false);
  const [ ready           , setReady           ] = useState (false)

  const fetchInformations = async () => {

    try
     {
      setShowWaitingIcon(true);

      if ( userId )
	   {
        const response = await getUserById ( userId );

        if ( response.code === 1 )
	     {
          setUser (response.payload)		   
		 }
	   }
     }
    catch (error)
     {
      console.error("Erreur lors de la récupération des sessions :", error);
     }
    finally
     {
      setShowWaitingIcon(false);
      setReady(true);  
     }
  };

  useEffect(() => {
    fetchInformations ()
  }, []);

  return (

           <div className={styles.root}>

			   {
				ready && user &&   
                <Tabs2 tabs = {[
                                 {
                                  label: 'Informations',
                                  children: <UserSheet user={user} />
                                 },
                                 {
                                   label: 'Live',
                                   children: <LiveStats userEmail={user.email}
                                                        userCreationDate={user.creationDate || undefined}
                                                        height='fit-content' />
                                 },
                                 {
                                   label: 'Replay',
                                   children: <ReplayStats userEmail={user.email}
                                                          userCreationDate={user.creationDate || undefined}
                                                          height='fit-content' />
                                 },
                                 {
                                   label: 'Commande',
                                   children: <PaymentList userEmail={user.email} />
                                 },
                                 {
                                   label: 'Connexions',
                                   children: <UserLogin userId={user.id} />
                                 },
                              ]}  
				/>
               }
			   
           </div>

  );
};

export default UserInformations2;
